export default {
  menu: {
    sports: "खेल",
    referAndEarn: "रेफर करें और कमाएं",
    referDesc: "60% तक कमीशन",
    copyLink: "लिंक कॉपी करें",
    hot: "लोकप्रिय",
    favorites: "पसंदीदा",
    recent: "हाल ही के",
    vipClub: "VIP क्लब",
    bonus: "बोनस",
    bonusGames: "बोनस गेम्स",
    affiliate: "सहयोगी",
    promotion: "प्रचार",
    rewards: "पुरस्कार",
    help: "सहायता",
    feedback: "प्रतिक्रिया",
    downloadApp: "ऐप डाउनलोड करें",
    claimBonus: "बोनस प्राप्त करें",
    redeemCode: 'कोड रिडीम करें',
    redeemDesc: 'मुफ़्त इनाम पाएं',
    liveSupport: "लाइव सहायता",
    language: "भाषा",
	search: "search"
  }
}
